module.exports = __webpack_public_path__ + "static/media/aandgmusic.58fa8ab7.png";